// extracted by css-extract-rspack-plugin
export default {"emphasis":"content-editor-plugin-emphasis-Emphasis-emphasis-d25ebf9d"};